import '.b9{position:relative;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.g9{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.bt{align-items:flex-start;}.ssr-plugin'
import '.s{padding:2rem;}.ssr-plugin'
import '.cr{background:var(--shades-white);}.ssr-plugin'
import '.l{overflow:hidden;}.ssr-plugin'
import '.h{position:absolute;}.ssr-plugin'
import '.ia{top:50%;}.ssr-plugin'
import '.ib{right:1rem;}.ssr-plugin'
import '.ic{transform:translateY(-50%);}.ssr-plugin'
import '.id{width:120px;}.ssr-plugin'
import '.ie{height:120px;}.ssr-plugin'
import '.if{z-index:0;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.hc{z-index:1;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.ig{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="b9 a0 g9 a m b bt s cr l"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="h ia ib ic id ie if a n b"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="b9 hc a m bt aj ig"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
